import axios from 'axios';
import store from '@/store/';
// appVersionSheetId, googleSheetkey
import { apiUrl } from '@/config/config/';
import { httpErrorHandler } from '@/libs/API/apiHelpers';
import { msgDialogControl } from '@/libs/global';
// import jwtDecode from 'jwt-decode';

let loadingTimerID = '';

const apiInstance = axios.create({
  baseURL: apiUrl
});

// const apiGoogleInstance = axios.create({
//   baseURL: 'https://sheets.googleapis.com/v4/'
// });

export const getEmployeeList = () =>
  apiInstance.get('emojiweb/member.json');

export const getFAQList = () =>
  apiInstance.get('qaandtutor/pxplus_faq.json');

export const getInstructionList = () =>
  apiInstance.get('qaandtutor/pxplus_instruction.json');

export const getNewsList = () =>
  apiInstance.get('qaandtutor/pxplus_news.json');

export const getPolicyDetail = (fileName = '') =>
  apiInstance.get(`Policy/${fileName}.txt`);

export const getBankRestriction = () =>
  apiInstance.get('qaandtutor/bank_restriction.json');

export const getDownloadsArea = () =>
  apiInstance.get('qaandtutor/file_download.json');

export const getAppVersion = () =>
  apiInstance.get('file_download/app_version.json');

export const getBankList = (bankType = 'homepage') =>
  apiInstance.get(`partner_bank/${bankType}_bank.json`);

// export const getAppVersion = () =>
// apiGoogleInstance.get(`spreadsheets/${appVersionSheetId}/values/Sheet1!A1:B3?key=${jwtDecode(googleSheetkey).key}`);

// apiInstance interceptors
apiInstance.interceptors.request.use(
  (config) => {
    showLoading();

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiInstance.interceptors.response.use(
  (res) => {
    hideLoading();

    if (res.data.code !== '0000') {
      msgDialogControl({ message: res.data.message, dialogType: 'alert' });
    }

    return res.data;
  },
  (error) => {
    hideLoading();

    // if (!error.response && error.message.includes('timeout')) {
    //   msgDialogControl({ message: error.message, dialogType: 'alert' });
    //   return;
    // }

    httpErrorHandler(error);

    return Promise.reject(error.response);
  }
);

// apiGoogleInstance interceptors
// apiGoogleInstance.interceptors.request.use(
//   (config) => {
//     showLoading();

//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// apiGoogleInstance.interceptors.response.use(
//   (res) => {
//     hideLoading();

//     return res.data;
//   },
//   (error) => {
//     hideLoading();

//     msgDialogControl({ message: '網路連線異常，請刷新網頁，取得app\n最新版本號', dialogType: 'alert' });

//     return Promise.reject(error.response);
//   }
// );

function showLoading () {
  loadingTimerID = setTimeout(() => {
    store.commit('page/SET_REQ_LOADING', true);
  }, 500);
}

function hideLoading () {
  window.clearTimeout(loadingTimerID);
  store.commit('page/SET_REQ_LOADING', false);
}
